module.exports = __webpack_public_path__ + "img/location.ead222f.webp";